import { Button } from '@savvy-kit/components/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@savvy-kit/components/empty';
import { cn } from '@savvy-kit/lib/utils';
import { RotateCw, TriangleAlert } from 'lucide-react';

import { CLIENT_PORTAL_RETRY_LABEL } from './constants';

type PortalCardErrorProps = {
  readonly title: string;
  readonly description: string;
  readonly onRetry: () => void;
  readonly className?: string;
};

export function PortalCardError({ title, description, onRetry, className }: PortalCardErrorProps) {
  return (
    <Empty role="alert" className={cn('gap-4 px-6 py-10 md:p-10', className)}>
      <EmptyHeader>
        <EmptyMedia variant="icon" className="border-border-light bg-vanilla text-secondary">
          <TriangleAlert />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="secondary" size="sm" onClick={onRetry}>
          <RotateCw size={14} />
          {CLIENT_PORTAL_RETRY_LABEL}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
